import React from "react";
import { bool, func } from "prop-types";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import { Modal } from "shared/components";
import VideoConferenceForm from "./VideoConferenceForm";
import IconRepair from "../../../../assets/svg/icone-reparo-modal.svg";

const ModalVideoConference = (props) => {
  const { isCurrentStep, onPreviousStep, onNextStep, onReset, t } = props;
  return (
    <Modal
      isOpen={isCurrentStep}
      onClose={onReset}
      title={t("MSG_0194")}
      icon={IconRepair}
      ariaHideApp={false}
    >
      <VideoConferenceForm
        onReset={onReset}
        onPreviousStep={onPreviousStep}
        onNextStep={onNextStep}
      />
    </Modal>
  );
};

ModalVideoConference.propTypes = {
  onCreateIncident: func.isRequired,
  onReset: func.isRequired,
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
  isOpen: bool,
};

ModalVideoConference.defaultProps = {
  isOpen: false,
};

const enhance = compose(translate());

export default enhance(ModalVideoConference);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalVideoConference/index.js